import { readApiErrorCode, readApiErrorMessage } from '@/lib/api';
import { isLyrraOne } from '@/lib/platform';
import { fetchLoSellerBilling } from '@/lib/lyrraone-hub';
import { toast } from '@/components/ui/Toast';

const BILLING_HINT = 'Paramètres → Facturation & société';

/** Affiche le message backend (ex. SELLER_BILLING_INCOMPLETE) au lieu d’un générique. */
export function notifyEduFlowPublishError(err: unknown, fallback: string): void {
  const code = readApiErrorCode(err);
  const msg = readApiErrorMessage(err, fallback);
  if (code === 'SELLER_BILLING_INCOMPLETE') {
    toast.error(msg, {
      description: `Complétez ${BILLING_HINT} (SIRET, adresse…) puis réessayez.`,
      duration: 14_000,
    });
    return;
  }
  toast.error(msg);
}

/** Bloque la publication si le profil vendeur LyrraOne est incomplet. */
export async function ensureSellerBillingForPublish(): Promise<boolean> {
  if (!isLyrraOne()) return true;
  try {
    const profile = await fetchLoSellerBilling();
    if (profile.complete) return true;
    toast.error(
      'Complétez vos informations de société avant de publier une formation.',
      {
        description: `${BILLING_HINT} — champs obligatoires : raison sociale, adresse, SIRET ou n° TVA.`,
        duration: 14_000,
      },
    );
    return false;
  } catch {
    return true;
  }
}
